import { render, staticRenderFns } from "./DemoTreeviewAppendAndLabel.vue?vue&type=template&id=11b5fbb0&"
import script from "./DemoTreeviewAppendAndLabel.vue?vue&type=script&lang=js&"
export * from "./DemoTreeviewAppendAndLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VTreeview})
